import {BussinessLine, type BussinessLineData} from "@/types/site_admin/bussiness-lines";

export class Package {
    public id:number|null;
    public name:string;
    public description:string;
    public businessLines:BussinessLine[];

    constructor(data:PackageData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.name = "";
            this.description = "";
            this.businessLines = [];
        }
        else
        {
            this.id = data.id;
            this.name = data.name;
            this.description = data.description;
            this.businessLines = [];
            if (data.businessLines !== undefined) {
                data.businessLines.forEach(bl => this.businessLines.push(new BussinessLine(bl)));
            }
        }
    }

    serializeData():PackageData {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            businessLines: this.businessLines.map(bl => (typeof (bl as any).serializeData === "function") ? bl.serializeData() : bl),
        }
    }
}

export type PackageData = {
    id:number|null;
    name:string;
    description:string;
    businessLines?:BussinessLineData[];
}
